import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import { Poll, PollList } from '../model/poll.model';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MaterialService } from './material.service';
import { AuthenticationService } from './authentification.service';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { environment } from '../../../../environments/environment';
import { PollResponseSubmit } from '../model/pollResponse.model';

@Injectable({
    providedIn: 'root'
})
export class PollService extends KiwixiService {
    private apiUrl = environment.server + 'polls/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
        private authentificationService: AuthenticationService
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getPolls(params: HttpParams): Observable<PollList> {
        const header = this.createHttpClientAuthorizationHeader();

        return this.http.get<PollList>(this.apiUrl, {
            headers: header,
            params: params
        }).pipe(
            map(polls => polls),
            catchError(this.handleErrorObservable<PollList>(`getObservableExaminations`))
        );
    }

    getPollsBySlug(params: HttpParams, auth_route): Observable<Poll> {
        return this.http.get<Poll>(this.apiUrl + auth_route + '/', {
            params: params
        }).pipe(
            map(polls => polls),
        );
    }

    getPoll(id: number): Observable<Poll> {
        const header = this.createHttpClientAuthorizationHeader();

        const url = `${this.apiUrl}${id}/`;
        return this.http.get<Poll>(url).pipe(
            catchError(this.handleErrorObservable<any>(`getPoll`))
        );;
    }

    postPoll(params: HttpParams): Observable<Poll> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<Poll>(this.apiUrl, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<Poll>(`Création d'un poll`)),
            );

    }

    patchPoll(url: string, params) {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<Poll>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<Poll>(`Patch d'un poll`)),
            );
    }

    deletePoll(id: number): Observable<any> {
        const header = this.createHttpClientAuthorizationHeader();
        const url = `${this.apiUrl}${id}/`;
        return this.http.delete(url);
    }

    savePollResponse(PollResponseSubmit: PollResponseSubmit, is_auth = true): Observable<any> {
        let route = 'get-or-save/';
        let headers = new HttpHeaders()
        if (!is_auth)
            route = 'no-auth-get-or-save/'
        else {
            headers = this.createHttpClientAuthorizationHeader();
        }
        return this._http.post<PollResponseSubmit>(this.apiUrl + route, PollResponseSubmit, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<any>(`Save PollResponse`)),
            );

    }
}
